import React from 'react';
import CustomTypography from '@src/new-components/Typography';
import { useTranslation } from 'react-i18next';
import Tooltip from '@src/components/Tooltip';
import { COLOR } from '@src/styles/color';

const CreditsCount = ({
  exceedBlockMaxCredits,
  credits,
  maxCredits,
  creditFactor,
}) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const renderNewUI = () => {
    if (creditFactor > 1) {
      return (
        <Tooltip
          arrow
          title={t('warningNoteCreditFactor', {
            credits: (credits * creditFactor).toLocaleString(language),
          })}
          placement="left"
        >
          <div>
            <CustomTypography
              variant="body-12-medium"
              color={COLOR.textPending}
              style={{
                padding: '4px 8px',
                borderRadius: '16px',
                backgroundColor: COLOR.backgroundDoubleChar,
                border: `1px solid ${COLOR.borderDoubleChar}`,
              }}
            >
              {t('doubleChar', {
                creditFactor,
              })}
            </CustomTypography>
          </div>
        </Tooltip>
      );
    }

    return null;
  };
  return (
    <div className="char-count">
      {renderNewUI()}
      <div>
        <span
          className={`text current-char-count ${
            exceedBlockMaxCredits && 'exceed-block-max-char'
          }`}
        >
          {credits.toLocaleString(language)}
        </span>
        <span className="text total-char-count">
          /{maxCredits.toLocaleString(language)}
        </span>
      </div>
    </div>
  );
};

export default CreditsCount;
